import React from 'react';

const MyClassmatesContext = React.createContext();

export default MyClassmatesContext;
